module.exports = __webpack_public_path__ + "static/media/combined_arms_bonus.206ec988.jpg";